import { TextField } from "@flat-ui";
import { AnalyticsFeedbackStepLayout } from "@components/analytics/in-house/feedback/analytics-feedback-step";
import {
  FeedbackStepDefinition,
  FeedbackStepProps,
} from "@components/analytics/in-house/feedback/analytics-feedback-types";

/** Free-text "one thing that would help you most" step. */
function AnalyticsFeedbackStep2Content({
  answers,
  onAnswersChange,
}: FeedbackStepProps): JSX.Element {
  return (
    <AnalyticsFeedbackStepLayout
      title="If we could make one improvement first, what would help you most?"
      subtext="We want analytics to do more for you. Tell us the single most valuable thing we could add or improve — and we'll start there."
    >
      <TextField
        multiline
        minRows={4}
        fullWidth
        placeholder="The one thing that would help you most…"
        text={answers.oneThing}
        onTextChanged={(oneThing) => onAnswersChange({ oneThing })}
      />
    </AnalyticsFeedbackStepLayout>
  );
}

/** Step definition registered in the survey flow. */
export const analyticsFeedbackStep2: FeedbackStepDefinition = {
  stepName: "oneThing",
  StepComponent: AnalyticsFeedbackStep2Content,
  isValid: () => true,
};
